import React, { useEffect } from 'react'
import _ from 'lodash'

import FiltersComponent from '../filters'
import * as FiltersConstants from '../filters/constants'
import { ALL_MEMBERS_FILTER_OPTION, DEFAULT_DATE_RANGE_FILTER, isOrgAdminView } from './helpers'

const noop = () => { }

/**
 * Analytics filters row — webapp analytics/components/filters.js behavior on
 * top of the CRM's generic FiltersComponent: date presets (+ Custom Range) for
 * everyone; Members submenu only when the viewed customer is an org owner/admin
 * (they'd see it in their own app); defaults set once options are available.
 */
const AnalyticsFilters = ({ client, viewedUser, memberOptions, filterState, onSetFilters, urlMemberId = null }) => {
  const showMemberFilter = isOrgAdminView(viewedUser)

  const clientFiltersConfig = FiltersConstants.ANALYTICS[client]

  const filters = showMemberFilter
    ? [{ name: 'Members', value: 'members', menus: memberOptions }, ...clientFiltersConfig.filters]
    : clientFiltersConfig.filters

  // webapp filters.js urlMemberId: deep-linked member becomes the default selection
  let defaultMemberFilter = { ...ALL_MEMBERS_FILTER_OPTION, filter_label: 'Members' }
  if (showMemberFilter && urlMemberId) {
    const deepLinkedMember = _.find(memberOptions, (option) => option.value.id === urlMemberId)
    if (!_.isEmpty(deepLinkedMember)) {
      defaultMemberFilter = { ...deepLinkedMember, filter_label: 'Members' }
    }
  }

  const defaultFilterState = showMemberFilter
    ? {
      members: defaultMemberFilter,
      date_range: DEFAULT_DATE_RANGE_FILTER
    }
    : { date_range: DEFAULT_DATE_RANGE_FILTER }

  const resetFilters = showMemberFilter
    ? { ...clientFiltersConfig.onResetFilters, members: { ...ALL_MEMBERS_FILTER_OPTION, filter_label: 'Members' } }
    : clientFiltersConfig.onResetFilters

  // webapp filters.js updateInitialStateOnComponentMount: apply defaults once
  // (for org views, only after the member options have loaded)
  useEffect(() => {
    if (_.isEmpty(filterState) && (!showMemberFilter || !_.isEmpty(memberOptions))) {
      onSetFilters(defaultFilterState)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterState, memberOptions, showMemberFilter])

  return (
    <FiltersComponent
      filterState={filterState}
      onSetFilters={onSetFilters}
      clearSearch={noop}
      filters={filters}
      filtersToInclude={FiltersConstants.FILTERS_TO_INCLUDE[client].ANALYTICS}
      resetFilters={resetFilters}
      className="analytics-filter"
      showCloseIcon={false}
    />
  )
}

export default AnalyticsFilters
